export default "__VITE_ASSET__ptkHrmHM__"